var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.studioURL)?_c('div',{staticClass:"col-12"},[_c('CompactEventsCalendar',{attrs:{"studioURL":_vm.studioURL,"openInNewWindow":true}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }